import { Component, Input, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'svg-icon',
  styleUrls: ['./svgIcon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <use [attr.xlink:href]="'#' + (prefix || 'svgIcon') + '-' + name"></use>
    </svg>
  `
})
export class SvgIconComponent {

  @Input() prefix: string | undefined;
  @Input() name: string | undefined;

  @HostBinding('class') get fullClassName(): string {
    return `icon ${this.name}${this.className ? ' ' + this.className : ''}`;
  }

  @Input() className: string | undefined;

  constructor(private _changeDetectorRef: ChangeDetectorRef) {
  }
}
